

import { Table,Thead,Tbody,Tr,Th,Td,TableContainer, Box,Menu,MenuButton,MenuList,
  MenuItem,IconButton,Divider,Icon} from "@chakra-ui/react"
import { CheckCircleIcon, HamburgerIcon,EditIcon,DeleteIcon } from '@chakra-ui/icons';
import { MdCheckBox,MdCheckBoxOutlineBlank, MdPrint } from "react-icons/md";

export const SpecifikacijaTable=({readonly=false,tableSize='xs',data,onDelete,onStartEdit,onCreateMigracija,onPrint})=>{




const getProvedena=(provedena)=>{
if (provedena) {
  return <Icon as={MdCheckBox} boxSize={5}/>
} else {
  return <Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>
}
}
const showData=()=>{
  
    return (
      <Box display={'flex'} flexDir={'column'} flex={1}>
        <TableContainer >
            <Table variant={'unstyled'} size={tableSize}>
                <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                    <Tr>
                        <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                        <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr</Th>
                        <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Šifra</Th>
                        <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                        <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum migracije</Th>
                        <Th w={'12%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Kamion</Th>
                        <Th w={'3%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj goveda</Th>
                        <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Operater</Th>
                        <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Provedena</Th>
                        <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dolazni posjednik</Th>
                    </Tr>
                </Thead>
                <Tbody>
                {data.map((item,i)=>{
                      return (
                        <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                        _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                            <Td fontSize={tableSize} textAlign={'center'}>
                              <Menu size={tableSize} zIndex={1}>
                                <MenuButton
                                    as={IconButton}
                                    aria-label='Options'
                                    icon={<HamburgerIcon />}
                                    variant={'outline'} size={tableSize}
                                    
                                />
                                <MenuList>
                                    
                                    <MenuItem size={tableSize} onClick={()=>onStartEdit(item.id,readonly || item.provedena)} icon={<EditIcon boxSize={'14px'} />}>Uredi / Pregled</MenuItem>
                                    <MenuItem isDisabled={readonly || !item.moze_se_provesti} onClick={()=>onCreateMigracija(item.id)}  size={tableSize} icon={<CheckCircleIcon boxSize={'14px'}/>}>Provedi</MenuItem>
                                    <Divider/>
                                      <MenuItem isDisabled={readonly} onClick={()=>onPrint('rep3',item.id)} size={tableSize} icon={<MdPrint size={'16px'}/>}>{process.env.REACT_APP_REP3_NAME}</MenuItem>
                                      <MenuItem isDisabled={readonly} onClick={()=>onPrint('rep4',item.id)}  size={tableSize} icon={<MdPrint size={'16px'}/>}>{process.env.REACT_APP_REP4_NAME}</MenuItem>
                                    <Divider/>
                                    <MenuItem isDisabled={readonly || item.provedena} onClick={()=>onDelete(item.id)} size={tableSize} icon={<DeleteIcon boxSize={'14px'} color={'red.700'}/>}>Briši</MenuItem>
                                </MenuList>
                              </Menu>
                              
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                {item.rbr}.
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                {item.id}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>
                              {new Date(item.datum.toString().split('T')[0]).toLocaleDateString('hr-HR')}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>
                              {new Date(item.migracija_datum.toString().split('T')[0]).toLocaleDateString('hr-HR')}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.kamion_br}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.brgoveda}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.operater}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                {getProvedena(item.provedena)}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>{item.dolazni_posjednik}</Td>
                        </Tr>
                      )
                })}
                </Tbody>
                </Table>
          </TableContainer>
      </Box>
    )
  
}

    return (
        <Box display={'flex'} flexDir={'row'} h={'100%'}>
          {showData()}
        </Box>
    )
}